import { ThumbUp, ThumbDown, Visibility } from "@mui/icons-material";
import "./ReactionToolTip.css";

const ReactionToolTip = ({ like, dislikes, views }) => {
    const checkGreaterThanTwoDigit = like > 99 || dislikes > 99 || views > 99;

    return (
        <div className="reaction-wrapper">
            <span className="reaction-icon">😎</span>

            <div
                className="reactiontoolcontainer"
                style={checkGreaterThanTwoDigit ? { left: "-500%" } : undefined}
            >
                <div className="reaction-row-like">
                    <ThumbUp fontSize="small" /> <span>{like}</span>
                </div>
                <div className="reaction-row-dislike">
                    <ThumbDown fontSize="small" /> <span>{dislikes}</span>
                </div>
                <div className="reaction-row-view">
                    <Visibility fontSize="small" /> <span>{views}</span>
                </div>
            </div>
        </div>
    );
};

export default ReactionToolTip;
